/* eslint-disable sort-keys-fix/sort-keys-fix -- CSS-in-JS pseudo-selector keys use semantic ordering */
// MUI v4 CardActions — NS/Tractie component overrides.
// All MUI v4 style classes are declared explicitly (no implicit inheritance on MUI defaults).
// Tractie deviation: padding 16 (Tractie inset-m, symmetrisch met CardHeader/CardContent)
// i.p.v. MUI default 8. Spacing tussen knoppen blijft 8 (= MUI default = Tractie gap-s).

export const MuiCardActionsLightOverrides = {
  root: {
    display: 'flex' as const,
    alignItems: 'center' as const,
    padding: 16,
    transition: 'none',
  },

  spacing: {
    '& > :not(:first-child)': {
      marginLeft: 8,
    },
  },
} as const;

// Dark variant — geen mode-specifieke overrides; layout/spacing zijn modes-agnostisch.
export const MuiCardActionsDarkOverrides = {
  ...MuiCardActionsLightOverrides,
} as const;
